var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { ShadowBox } from '@hn-ui/boxes';
import { styled } from 'styled-components';
var FormSection = styled(ShadowBox).withConfig({ displayName: "FormSection", componentId: "sc-x9c867" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  [data-id='content-box'] {\n    padding: 32px 40px 40px;\n  }\n"], ["\n  [data-id='content-box'] {\n    padding: 32px 40px 40px;\n  }\n"])));
export { FormSection };
var templateObject_1;
